var BaseActivityConfiguration = /** @class */ (function () {
    function BaseActivityConfiguration(workflowConfigurationService) {
        this.workflowConfigurationService = workflowConfigurationService;
    }
    BaseActivityConfiguration.prototype.activate = function (model) {
        if (!model) {
            return;
        }
        this.item = model.activity;
        this.meta = model.activity.meta ? JSON.parse(model.activity.meta) : {};
        this.entity = model.entity;
        this.onActivated();
    };
    BaseActivityConfiguration.prototype.deactivate = function () {
        this.item = null;
        this.meta = null;
        this.entity = null;
    };
    BaseActivityConfiguration.prototype.onActivated = function () { };
    BaseActivityConfiguration.prototype.setMeta = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.item.meta = JSON.stringify(_this.meta);
            resolve();
        });
    };
    return BaseActivityConfiguration;
}());
export { BaseActivityConfiguration };
